import React from 'react'
import { lower } from 'change-case'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { compose, lifecycle } from 'recompose'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Fade, Card, CardHeader, CardContent, CircularProgress } from '@material-ui/core'
import { ProcurementBody } from '../../../styled'
import { BottomActionsContainer } from '../styled'
import { getCategory, getSubCategory, getDocumentTypes } from '../../helper'
import { AttachmentContainer, AttachmentFormContainer } from './styled'
import { getAttachmentTypes } from 'ducks/purchaseRequisition'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import r from 'reactotron-react-js'

var documentTypes = []

const Attachment = (props) => {
  const { valueForm: { special, isAdditional }, setFormStep, handleSubmit,
    attachmentType, loading } = props

  documentTypes = getDocumentTypes(attachmentType, special, isAdditional)
  r.log({ documentTypes, attachmentType })
  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <form onSubmit={handleSubmit}>
          <AttachmentContainer>
            <Card>
              <CardHeader 
                title='Attachments'
                action={
                  <div className='cardHeaderActions'>
                    <Button type='button' className='hiddenButton' circular icon='chevron up' />
                  </div>
                }
              />
              <CardContent>
                <AttachmentFormContainer>
                  { loading ? 
                    <CircularProgress color='primary' /> : 
                    documentTypes.map(dt => 
                      <Field
                        key={lower(dt.code)}
                        name={lower(dt.code)}
                        label={dt.name}
                        require={dt.isRequire}
                        type={type.file}
                        component={FieldInput} />
                    )}
                  <Field name='pr15' label='Others' require={false} type={type.file} component={FieldInput} />
                </AttachmentFormContainer>
                <div>
                  <span>หมายเหตุ / Note: </span>
                  <ul style={{marginTop:'0.3rem'}}>
                    <li>รองรับได้สูงสุด 250 MB ต่อไฟล์ / The maximum file size is 250 MB (per file).</li>
                    <li>ความเร็วและข้อผิดพลาดในการอัพโหลด/ดาวน์โหลดไฟล์ขนาดใหญ่ ขึ้นอยู่กับอินเตอร์เน็ตที่ท่านใช้งาน / The speed and error in uploading or downloading depend on your internet connection.</li>
                  </ul>
                </div>
              </CardContent>
            </Card>
            <BottomActionsContainer>
              <Button 
                type='button'
                content='Back'
                icon='arrow left' 
                labelPosition='left'
                color='red'
                onClick={() => setFormStep(3)} 
              /> 
              <Button 
                type='submit'
                content='Next' 
                color='blue' 
                icon='arrow right' 
                // onClick={() => setFormStep(5)}
                labelPosition='right'
              />
            </BottomActionsContainer>
          </AttachmentContainer>
        </form>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state) => {
  const valueForm = getFormValues('formCreatePR')(state) || {}
  const menus = state.pr.menus || []
  var category = {}
  var subCategory = {}

  if (valueForm) {
    if (valueForm.menuCategory) {
      category = getCategory(menus)(valueForm.menuCategory)
    }

    if (valueForm.menuSubCategory && category.subCategories) {
      subCategory = getSubCategory(category.subCategories)(valueForm.menuSubCategory)
    }
  }

  var attachType = ''
  if (valueForm.companyCode) {
    if (subCategory.attachmentType) {
      attachType = subCategory.attachmentType
    } else {
      if (subCategory.attachmentTypes[valueForm.companyCode]) {
        attachType = subCategory.attachmentTypes[valueForm.companyCode]
      } else if (subCategory.attachmentTypes['all']) {
        attachType = subCategory.attachmentTypes['all']
      }
    }
  }

  const attachmentTypes = state.pr.attachmentTypes
  const attachmentType = attachmentTypes.find(a => a.code === attachType)

  return ({
    attachmentTypes,
    attachmentType,
    loading: state.pr.attachmentTypeLoading,
    initialValues: {
      ...valueForm,
    },
    valueForm
  })
}

const mapDispatchToProps = {
  getAttachmentTypes
}

const validate = values => {
  const errors = {}

  // documentTypes.forEach((dt) => {
  //   if (dt.isRequire) {
  //     let docValue = values[lower(dt.code)]
  //     if (docValue) {
  //       if (!docValue.length) {
  //         errors[lower(dt.code)] = 'Required!'
  //       }
  //     } else {
  //       errors[lower(dt.code)] = 'Required!'
  //     }
  //   }
  // })

  return errors
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formCreatePR',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.attachmentTypes.length === 0) {
        this.props.getAttachmentTypes()
      }
    },
  })
)

export default enhance(Attachment)
